export enum USER_TYPES {
  INSTITUTION = "institution_user",
}
